module.exports = __webpack_public_path__ + "img/UAV_data-3.9df907dc.png";